import { PluginDefinition } from 'yam-types'
import configOperator from './handlers/config'
import secretOperator from './handlers/secret'
import initConfigAndSecrets from './handlers/initialize'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { ApplicationSecret, Configuration } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'config[?(@.type=="configMap")]': configOperator,
    'config[?(@.type=="secret")]': secretOperator,
    "beforePlan": initConfigAndSecrets
  }
} as PluginDefinition<Configuration | ApplicationSecret>